import { features } from '@/mocks/content';

export default function FeaturesSection() {
  const [main, ...rest] = features;

  return (
    <section id="features" className="scroll-mt-nav py-12 md:py-16">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="max-w-2xl">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 flex items-center gap-2">
              <i className="ri-bookmark-3-line text-accent-500"></i>
              专题推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              围绕一条线索把相关内容串起来，比零散浏览更容易看懂一个主题的全貌。
            </p>
          </div>

          <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
            <a
              href="#collections"
              className="group flex flex-col bg-background-50 border border-background-200 rounded-lg overflow-hidden cursor-pointer transition-colors hover:border-primary-300"
            >
              <div className="relative w-full h-56 md:h-72 overflow-hidden">
                <img
                  src={main.cover}
                  alt={`${main.title} 专题封面`}
                  title={`${main.title} - 91精选专题推荐`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                  {main.label}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
                  {main.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{main.summary}</p>
              </div>
            </a>

            <div className="grid grid-cols-1 gap-4 md:gap-5">
              {rest.map((item) => (
                <a
                  key={item.id}
                  href="#collections"
                  className="group flex bg-background-50 border border-background-200 rounded-lg overflow-hidden cursor-pointer transition-colors hover:border-primary-300"
                >
                  <div className="w-32 sm:w-44 flex-shrink-0 overflow-hidden">
                    <img
                      src={item.cover}
                      alt={`${item.title} 专题封面`}
                      title={`${item.title} - 91精选专题推荐`}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="flex flex-col justify-center p-4 md:p-5 min-w-0">
                    <span className="self-start px-2.5 py-0.5 rounded-full bg-primary-100 text-primary-800 text-[11px] font-medium">
                      {item.label}
                    </span>
                    <h3 className="mt-2 font-heading text-base font-bold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                      {item.title}
                    </h3>
                    <p className="mt-1.5 text-xs leading-relaxed text-foreground-600 line-clamp-2">
                      {item.summary}
                    </p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}